import SupplierAccountForm from "../../../components/AccountComponents/SupplierAccountsForm";

function NewSupplierAccountPage(){
    return(<SupplierAccountForm method="post"  title="supplier"/>)
}


export default NewSupplierAccountPage;